import { types } from './TestingExercisingAction';

const initialState = {
  loadingScenarios: false,
  loadingSubmissions: false,
  loadingSubmissionDetail: false,
  submissionRequest: false,
  usingMock: false,
  industryId: null,
  industryName: null,
  industries: [],
  scenarios: [],
  scenarioSubmissions: [],
  scenarioSubmissionsMeta: null,
  submissionDetail: null,
};

export default function testingExercisingReducer(state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_SCENARIOS:
      return { ...state, loadingScenarios: true };
    case types.RECEIVE_SCENARIOS: {
      const payload = action.payload || {};
      return {
        ...state,
        loadingScenarios: false,
        industryId: payload.industryId ?? null,
        industryName: payload.industryName ?? null,
        industries: Array.isArray(payload.industries) ? payload.industries : state.industries,
        scenarios: Array.isArray(payload.scenarios) ? payload.scenarios : [],
      };
    }
    case types.REQUEST_SCENARIO_SUBMISSIONS:
      return { ...state, loadingSubmissions: true };
    case types.RECEIVE_SCENARIO_SUBMISSIONS: {
      const payload = action.payload || {};
      return {
        ...state,
        loadingSubmissions: false,
        scenarioSubmissions: Array.isArray(payload.submissions) ? payload.submissions : [],
        scenarioSubmissionsMeta: {
          planId: payload.planId,
          scenarioId: payload.scenarioId,
          scenarioHeading: payload.scenarioHeading,
        },
      };
    }
    case types.REQUEST_SUBMISSION_DETAIL:
      return { ...state, loadingSubmissionDetail: true };
    case types.RECEIVE_SUBMISSION_DETAIL:
      return { ...state, loadingSubmissionDetail: false, submissionDetail: action.payload };
    case types.SET_SUBMISSION_REQUEST:
      return { ...state, submissionRequest: Boolean(action.value) };
    case types.SET_USING_MOCK:
      return { ...state, usingMock: Boolean(action.value) };
    default:
      return state;
  }
}
